import api from '../api';

export default {
  computed: {
    btnCodeText() {
      return this.sending ? '发送中' : (this.downTime > 0 ? this.downTime + '秒' : '获取验证码');
    }
  },
  data() {
    return {
      downTime: 0,
      sending: false
    };
  },
  methods: {
    async sendCaptchaCode() {
      await api.get('/api/public/login/sms_code', {
        params: {
          phone: this.CellPhoneNo
        }
      });
    },
    async checkCaptcha() {
      await this.$store.dispatch('postData', {
        url: '/common/CheckCaptcha',
        data: {
          Body: {
            CellPhoneNo: this.CellPhoneNo,
            CaptchaType: this.CaptchaType,
            Captcha: this.Captcha
          }
        }
      });
    },
    validMobile() {
      const reg = /^1[0-9]{10}$/;
      return reg.test(this.CellPhoneNo);
    },
    async sendCaptcha() {
      if (this.sending || this.downTime > 0) {
        return;
      }
      if (this.CaptchaType <= 0) {
        this.$warning('请先配置验证码类型');
        return;
      }
      if (!this.validMobile()) {
        this.$warning('请输入正确的手机号');
        return;
      }
      try {
        this.sending = true;
        await this.sendCaptchaCode();
        this.sending = false;
        this.$toast('验证码已发送');
        this.downTime = 60;
        let clearId = setInterval(() => {
          if (this.downTime === 0) {
            clearInterval(clearId);
          }
          if (this.downTime > 0) {
            this.downTime--;
          }
        }, 1000);
      } catch (e) {
        this.sending = false;
        this.$error(e.message);
      }
    }
  }
};
